const LANGUAGE = {
  populatedFromSurveyWarning: {
    Text: 'Please edit this section and confirm all the submitted information.',
    Title: 'Some information was automatically added via survey',
  },
};

export const LANGUAGEV2 = {
  populatedFromSurveyWarning: {
    Text: 'Please review and confirm all submitted fields',
    Title: 'Some fields below were filled automatically based on survey data.',
  },
};

export default LANGUAGE;
